import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94730f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "row d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FounderDetailsCard = _resolveComponent("FounderDetailsCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connectedFounders, (founder) => {
      return (_openBlock(), _createElementBlock("div", {
        key: founder.id,
        class: "col-md-4 my-4"
      }, [
        _createVNode(_component_FounderDetailsCard, {
          name: founder.firstName + ' ' + founder.lastName,
          jobTitle: founder.jobTitle,
          profilePicture: founder?.profileImage,
          linkedInProfile: founder.linkedInProfileUrl,
          introduction: founder.introduction,
          online: true,
          founderId: founder.id + '',
          avatar: "media/avatars/blank.png",
          connected: false,
          "avg-earnings": "$14,560",
          "total-sales": "$236,400",
          fromConnectedExperts: true
        }, null, 8, ["name", "jobTitle", "profilePicture", "linkedInProfile", "introduction", "founderId"])
      ]))
    }), 128)),
    (_ctx.connectedFounders?.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No Connected Founders "))
      : _createCommentVNode("", true)
  ]))
}